import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const TemplateViewComponent = ({template}) => {
    return (
        <div className="container mt-5">
            
                <div className="card-body" style={{ padding: '10px' }}>
                    {/* Header */}
                    {template.template_header_text && (
                        <h5
                            className="card-title text-center"
                            style={{ color: '#075e54', fontWeight: 'bold' }} // WhatsApp-like dark green text
                        >
                            {template.template_header_text}
                        </h5>
                    )}

                    {/* Media */}
                    {template.template_media_url && (
                        <div className="text-center mb-3">
                            <img
                                src={template.template_media_url}
                                alt="Template Media"
                                className="img-fluid rounded"
                                style={{
                                    maxHeight: '200px',
                                    borderRadius: '8px',
                                    border: '1px solid #d4edda',
                                }}
                            />
                        </div>
                    )}

                    {/* Message Body */}
                    <p
                        className="card-text"
                        style={{
                            color: '#075e54', // WhatsApp-like dark green text
                            fontSize: '14px',
                            lineHeight: '1.5',
                        }}
                    >
                        {template.template_message_body}
                    </p>

                    {/* Buttons */}
                    {template.button_json && template.button_json.length > 0 && (
                        <div className="mt-3">
                            {template.button_json.map((button, index) => (
                                <div key={index} className="d-grid gap-2 mb-2">
                                    {button.type === 'quick_reply' && (
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                color: '#075e54',
                                                borderColor: '#d4edda',
                                            }}
                                        >
                                            {button.content}
                                        </button>
                                    )}
                                    {button.type === 'visit_website' && (
                                        <a
                                            href={button.site_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-primary btn-sm"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                color: '#075e54',
                                                borderColor: '#d4edda',
                                            }}
                                        >
                                            {button.button}
                                        </a>
                                    )}
                                    {button.type === 'call_phone' && (
                                        <a
                                            href={`tel:${button.site_url}`}
                                            className="btn btn-outline-success btn-sm"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                color: '#075e54',
                                                borderColor: '#d4edda',
                                            }}
                                        >
                                            {button.button}
                                        </a>
                                    )}
                                    {button.type === 'copy_offer' && (
                                            <button className="btn btn-outline-secondary btn-sm" style={{
                                                backgroundColor: '#ffffff',
                                                color: '#075e54',
                                                borderColor: '#d4edda',
                                            }}>
                                                {button.site_url} 
                                            <i className="bi bi-clipboard"></i> {/* Bootstrap clipboard icon */}
                                            </button>
                                    )}
                                    {button.type === 'opt_out' && (
                                            <button className="btn btn-outline-secondary btn-sm" style={{
                                                backgroundColor: '#ffffff',
                                                color: '#075e54',
                                                borderColor: '#d4edda',
                                            }}>
                                                Stop Promotion 
                                            </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Footer */}
                    {template.template_footer_text && (
                        <div
                            className="text-muted text-center mt-3"
                            style={{ color: '#4a4a4a', fontSize: '12px' }}
                        >
                            <small>{template.template_footer_text}</small>
                        </div>
                    )}
                </div>
           
        </div>
    );
};


export default TemplateViewComponent;